import SafeguardingEvent from '../domain/models/SafeguardingEvent';
import MedicalEvent from '../domain/models/MedicalEvent';
import PoliceEvent from '../domain/models/PoliceEvent';

export default class SafeguardingService {
  constructor(studentService) {
    this.studentService = studentService;
  }

  addEvent(studentId, data, user) {
    const student = this.studentService.getById(studentId);
    if (!student) return null;
    const event = new SafeguardingEvent(data);
    const updatedEvents = [event.toJSON(), ...student.safeguardingEvents.map((e) => e.toJSON())];
    return this.studentService.update(
      studentId,
      { safeguardingEvents: updatedEvents, lastUpdated: new Date().toISOString() },
      user
    );
  }

  addMedicalEvent(studentId, data, user) {
    const student = this.studentService.getById(studentId);
    if (!student) return null;
    const event = new MedicalEvent(data);
    const updatedEvents = [event.toJSON(), ...student.medicalEvents.map((e) => e.toJSON())];
    return this.studentService.update(
      studentId,
      { medicalEvents: updatedEvents, lastUpdated: new Date().toISOString() },
      user
    );
  }

  addPoliceEvent(studentId, data, user) {
    const student = this.studentService.getById(studentId);
    if (!student) return null;
    const event = new PoliceEvent(data);
    const updatedEvents = [event.toJSON(), ...student.policeEvents.map((e) => e.toJSON())];
    return this.studentService.update(
      studentId,
      { policeEvents: updatedEvents, lastUpdated: new Date().toISOString() },
      user
    );
  }

  getActive(student) {
    return student.safeguardingEvents.filter((e) => e.status === 'open');
  }
}
